<ul class="h-full relative block" id="cart-list">
  <li class="h-full relative section z-20">
    <app-cart-section-item
      [data]="seatsBySection"
      [showSeats]="showSeats"
      [isTicketFeeEnabled]="isTicketFeeEnabled"
      (toggle)="toggleSeats()" />
  </li>

  <div
    class="z-0 h-0 bg-gray-100 block relative overflow-hidden divide-y divide-gray-300"
    #seatsContainer>
    @for (row of seatsBySection.rows; track row.id) {
      <div class="divide-y divide-gray-300">
        @for (
          seat of row.seats;
          let idx = $index;
          track seat.id + seat.original_id
        ) {
          <li>
            <app-cart-seat-item
              class="divide-y divide-gray-300"
              [data]="seat"
              [isTicketFeeEnabled]="isTicketFeeEnabled"
              [seatIndex]="idx" />
          </li>
        }
      </div>
    }
  </div>
</ul>
